import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel from "@/__main__/data-model.mjs";
import QueueSymbol from "@/game-lol/utils/symbol-queue.mjs";
import RoleSymbol from "@/game-lol/utils/symbol-role.mjs";

const MinionStatsObject = {
  minionsKilledEnemyJungle: Number,
  minionsKilledNeutral: Number,
  minionsKilledTeamJungle: Number,
  minionsKilledTotal: Number,
} satisfies ModelDefinition;

const MultiKillStatsObject = {
  doubleKills: Number,
  killingSprees: Number,
  pentaKills: Number,
  quadraKills: Number,
  tripleKills: Number,
} satisfies ModelDefinition;

const WardStatsObject = {
  wardsKilled: Number,
  wardsPlaced: Number,
  wardsPurchased: Number,
} satisfies ModelDefinition;

const GoldStatsObject = {
  goldEarned: Number,
  goldSpent: Number,
} satisfies ModelDefinition;

const FirstStatsObject = {
  firstBlood: Number,
  firstInhibitorKill: Number,
  firstTowerKill: Number,
} satisfies ModelDefinition;

const DamageStatsObject = {
  damageDealt: Number,
  damageHealed: Number,
  damageMagicDealt: Number,
  damagePhysicalDealt: Number,
  damageSelfMitigated: Number,
  damageTaken: Number,
  damageToChampions: Number,
  damageToObjectives: Number,
  damageToTowers: Number,
  damageTrueDealt: Number,
} satisfies ModelDefinition;

const CCStatsObject = {
  timeCcOthers: Number,
  totalTimeCcDealt: Number,
} satisfies ModelDefinition;

const BasicStatsObject = {
  assists: Number,
  deaths: Number,
  kills: Number,
  lp: Number,
  lpEstimate: Number,
  visionScore: Number,
  wins: Number,
} satisfies ModelDefinition;

export const model = {
  basicStats: BasicStatsObject,
  ccStats: CCStatsObject,
  championId: Number,
  damageStats: DamageStatsObject,
  firstStats: FirstStatsObject,
  gameCount: Number,
  gameDuration: Number,
  goldDiffAtLaneEnd: Number,
  goldStats: GoldStatsObject,
  lastPlayed: String,
  minionStats: MinionStatsObject,
  multikillStats: MultiKillStatsObject,
  queue: QueueSymbol,
  role: RoleSymbol,
  wardStats: WardStatsObject,
} satisfies ModelDefinition;

const PlayerChampionStatsModel = createModel({
  data: {
    playerChampionsStats: [model],
  },
}).transform([model], (data) => data.data.playerChampionsStats);

export type PlayerChampionStats = FromModel<typeof PlayerChampionStatsModel>;

export default PlayerChampionStatsModel;
